module.exports = __webpack_public_path__ + "static/img/ginger_pictgrid14_500x530.774a95b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ginger_pictgrid14_500x530.jpg
// module id = 1DQR
// module chunks = 0